// removed by extract-text-webpack-plugin
module.exports = {"Controls":"resourceList__Controls__UNp3w","Search":"resourceList__Search__1wCzl","ResourceHeader":"resourceList__ResourceHeader__3ti-A","Row":"resourceList__Row__9olGD","Col":"resourceList__Col__1OXwa","Label":"resourceList__Label__2R8OM","Select":"resourceList__Select__JL5AJ","SortUIContainer":"resourceList__SortUIContainer__pqEOD","SortSelection":"resourceList__SortSelection__1bSrZ","FilterSelection":"resourceList__FilterSelection__1gwHY","CustomIcon":"resourceList__CustomIcon__1NsMW"};


//////////////////
// WEBPACK FOOTER
// ./src/Layout/Dashboard/MainContent/resourceList.css
// module id = 1706
// module chunks = 2